import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col, Button } from 'reactstrap';

import ComplianceActivityEvidenceItem from './item';

const ComplianceActivityEvidenceList = (props) => {
  const {
    evidences,
    configuration: {
      formName,
    },
    callbacks: {
      onChangeActivity: callbackOnChangeActivity
    }
  } = props;

  const addNewEvidence = (e) => {
    let _evidences = [... evidences]

    let evidenceAttributes = {
      id: "",
      name: "",
      template: null,
      is_recurrent: true,
      children: [],
      _destroy: false,
    }

    _evidences.push(evidenceAttributes)

    if(_.isFunction(callbackOnChangeActivity)){
      callbackOnChangeActivity({target: {value: _evidences }}, 'evidences')
    }
  }

  const onChangeEvidences = (index, evidence) => {
    let _evidences = [... evidences]
    _evidences[index] = evidence

    if(_.isFunction(callbackOnChangeActivity)){
      callbackOnChangeActivity({target: {value: _evidences}}, 'evidences')
    }
  }

  const renderEvidences = () => {
    let availableEvidences = _.filter(evidences, (evidence) => {
      return !evidence._destroy
    })

    if(availableEvidences?.length > 0){
      return(
        <Row>
          <Col md={12}>
            {
              _.map(availableEvidences, (evidence, index) => {
                return (
                  <ComplianceActivityEvidenceItem
                    key={ `evidenceItem-${ index }` }
                    index={ index }
                    evidence={ evidence }
                    configuration={{
                      formName: `${ formName }[${ index }]`,
                    }}
                    callbacks={{
                      onChangeEvidences: onChangeEvidences
                    }}
                  />
                )
              })
            }
          </Col>
        </Row>
      )
    } else {
      return(
        <Row>
          <Col md={12}>
            <div className="alert alert-primary text-center">
              <i className="fas fa-info-circle mr-2" aria-hidden="true" title="Información"></i>
              <span>{ I18n.t(`messages.without_results`) }</span>
            </div>
          </Col>
        </Row>
      )
    }
  }

  return (
    <Row key={`evidenceList`}>
      <Col md={12}>
        { renderEvidences() }
      </Col>
      <Col md={12}>
        <Button
            outline
            color="success"
            size="sm"
            onClick={ e => addNewEvidence(e) }
          >
          <i className="fa fa-plus"></i>
          &nbsp;
          { I18n.t("actions.create") } Documento
        </Button>
      </Col>
    </Row>
  )
}

export default ComplianceActivityEvidenceList;
